import * as React from 'react';
import styled from 'styled-components';
import DashboardLayout from '../layouts/DashboardLayout';
import DashboardInspectionsPage from './DashboardInspectionsPage';

const DashboardPageInspector = () => {
  return (
    <DashboardLayout>
      <Container>
        <DashboardInspectionsPage />
      </Container>
    </DashboardLayout>
  );
};

const Container = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: stretch;
  padding: 20px 16px 0;
  background: var(--app-bg, var(--defaultBackground));
  font-family: 'Segoe UI', -apple-system, BlinkMacSystemFont, 'Helvetica Neue', Arial, Roboto, sans-serif;
`;

export default DashboardPageInspector;
